export default __webpack_public_path__ + "media/projects/purple1-thumb-57929365.svg";